import { useState, useRef } from 'react';
import './AgoraList.css';

const AgoraList = ({ data, setData, page, setPage }) => {
  const [editIndex, setEditIndex] = useState();
  const [isEditNow, setIsEditNow] = useState(false);
  const title = useRef();
  const handlePagination = (e) => {
    console.log(e.target.name);
    if (e.target.name === 'prev') {
      if (page === 1) {
        return;
      } else {
        setPage(page - 1);
      }
    }
    if (e.target.name === 'next') {
      setPage(page + 1);
    }
  };
  return (
    <>
      <section className='AgoraList'>
        <ul className='discussions__container'>
          {data.map((el, index) => {
            const handleDelete = () => {
              // const date =new Date(el.createdAt)
              console.log(el.id);
              fetch(`http://localhost:3001/discussions/${el.id}`, {
                method: 'DELETE',
                body: '',
                redirect: 'follow',
              })
                .then((res) => res.json())
                .then((data) => {
                  alert('테스트중');
                  console.log(data);
                  setData(data);
                });
            };
            const handleEdit = () => {
              console.log(title.current.value);
              const body = {
                title: title.current.value,
              };
              console.log(body);
              fetch(`http://localhost:3001/discussions/${el.id}`, {
                method: 'PUT',
                body: JSON.stringify(body),
                headers: {
                  'Content-Type': 'application/json',
                },
                redirect: 'follow',
              })
                .then((res) => res.json())
                .then((data) => {
                  alert('테스트중');
                  setIsEditNow(!isEditNow);
                  setData(data);
                });
            };
            const isEdit = () => {
              setEditIndex(el.id);
              setIsEditNow(!isEditNow);
            };
            return (
              <li className='discussion__container' key={el.id}>
                <div className='editNdelete'>
                  <span onClick={isEdit}>수정</span>
                  <span onClick={handleDelete}>삭제</span>
                </div>

                <div className='discussion__avatar--wrapper'>
                  <img
                    className='discussion__avatar--image'
                    src={el.avatarUrl}
                    alt={'avatar of' + el.author}
                  />
                </div>
                {el.id === editIndex && isEditNow === true ? (
                  <div className='discussion__content'>
                    <textarea
                      ref={title}
                      defaultValue={el.title}
                      style={{ width: '90%' }}
                    />
                    <button onClick={handleEdit}>수정하기</button>
                  </div>
                ) : (
                  <div className='discussion__content'>
                    <h2 className='discussion__title'>
                      <a href={el.url}>{el.title}</a>
                    </h2>
                    <div className='discussion__information'>
                      <span className='userInfo'>
                        {el.author} / {el.createdAt}
                      </span>
                      <span className='isAnswer'>
                        {el.answer !== null ? '  answered' : '  unanswered'}
                      </span>
                      <input
                        className='discussionId'
                        type='hidden'
                        value={el.id}
                      />
                    </div>
                  </div>
                )}
                <div className='discussion__answered material-icons'>
                  {el.answer !== null ? '✔' : '❌'}
                </div>
              </li>
            );
          })}
        </ul>
      </section>
      <div className='page__btn'>
        <button onClick={handlePagination} name='prev'>
          prev
        </button>
        <button onClick={handlePagination} name='next'>
          next
        </button>
      </div>
    </>
  );
};
export default AgoraList;
